var map = {
	"./russianroulette_en.png": "roS+",
	"./russianroulette_esp.png": "dZpR",
	"./russianroulette_th.png": "1tfH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yKkc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/russianroulette_.*\.png$
// module id = yKkc
// module chunks = 1